export function DateMask(): string {
  return '00/00/0000';
}
